import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';

@Component({
	selector: 'app-modal-info',
	templateUrl: './modal-info.component.html',
	styleUrls: ['./modal-info.component.styl'],
})
export class SharedModalInfoComponent implements OnInit {

	@Input() title = '';
	@Input() topText = '';
	@Input() text = '';
	@Input() btnName = '';
	@Input() btnBackName = '';

	constructor(
		public dialogRef: MatDialogRef<SharedModalInfoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.title = data.title ? data.title : null;
		this.topText = data.topText ? data.topText : null;
		this.text = data.text ? data.text : null;
		this.btnName = data.btnName ? data.btnName : null;
		this.btnBackName = data.btnBackName ? data.btnBackName : null;
	}

	ngOnInit(): void {
	}

	onClose(): void {
		this.dialogRef.close(false);
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-info/modal-info.component.ts